import React from 'react';
import Page from '../../lib/page';
import { Tabs } from 'antd';
import { BigBanner } from '../../component';
import Home from './home';
import NewChannel from './newchannel';
import NewRank from './newrank';
import NewUpdateBook from './newupdate';
import styles from './index.css';

export default class HomePage extends Page {
    constructor(props) {
        super(props)
        this.state = {
            book_home_update: [],
        }
    }

    getUpdateBook = (novel_list) => {
        this.setState({
            book_home_update: novel_list
        })
    }

    render() {
        return (
            <div className={styles.container}>
                <BigBanner />
                <Home />
                {/* <div style={{ position: 'relative', width: '1000px', margin: '0 auto 40px' }}>
                    <Tabs
                        style={{ marginTop: '29px' }}
                        defaultActiveKey="1"
                        tabBarExtraContent={<h3 style={{ fontSize: '26px', color: '#333', lineHeight: '26px', margin: '0px', position: 'absolute', left: '0' }}>重磅好书</h3>}
                        tabBarStyle={{ textAlign: 'right' }}>
                        <Tabs.TabPane tab={<span className={styles.tab_header + ' ' + styles.tab_header_divider}>男频</span>} key="1">
                            <NewChannel channel_id={2} />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={<span className={styles.tab_header}>女频</span>} key="2">
                            <NewChannel channel_id={3} />
                        </Tabs.TabPane>
                    </Tabs>
                </div> */}
                {/* <NewRank /> */}
                {/* <NewUpdateBook updataBook={this.state.book_home_update} /> */}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/layout/home/index.js